export default {
    failedToRemoveProductsDueToLoadedContainer: "ไม่สามารถลบสินค้าได้ เนื่องจากมี {{no}} รายการถูกโหลดเข้าตู้คอนเทนเนอร์แล้ว",
    atLeast1ProductIsRequired: "ต้องเลือกสินค้าขั้นต่ำอย่างน้อย 1 รายการ",
    added1NewProductEntry: 'เพิ่มข้อมูลสินค้าใหม่ 1 รายการแล้ว',
    selected1Item: 'เลือกรายการ 1 รายการ',
    added1NewItemEntry: 'เพิ่มรายการใหม่ 1 รายการแล้ว',
    thereAreSomeProductsAlreadyLoadedToTheContainers: 'มีสินค้าบางรายการที่ถูกโหลดเข้าตู้คอนเทนเนอร์แล้ว',
    itemsAtLeastHave1Row: 'ต้องมีอย่างน้อย (1) แถว',
    pleaseSelectAllTheShippingRatesToProceed: 'กรุณาเลือกอัตราการจัดส่งทั้งหมดเพื่อดำเนินการต่อ',
    mustSelectAtLeast1Selection: 'ต้องเลือกอย่างน้อย 1 รายการ',
    pleaseSelectContainer: 'กรุณาเลือกตู้คอนเทนเนอร์',
    thereIsNotItemsRelatedToThisContainer: 'ไม่มีรายการที่เกี่ยวข้องกับตู้คอนเทนเนอร์นี้',
    supplierOrContainerAreNotYetSelectedPleaseSelectBothForNextStep: 'ยังไม่ได้เลือกผู้จัดส่งหรือตู้คอนเทนเนอร์ กรุณาเลือกทั้งสองอย่างเพื่อดำเนินการขั้นถัดไป',
    youHaveToSelectTheFullQtyIfThereIsNotSplitOption: 'คุณต้องเลือกจำนวนเต็ม หากไม่มีตัวเลือกการแบ่ง',
    youHaveToSelectTheQtyAtLeastMoreThan1Qty: 'ต้องเลือกจำนวนอย่างน้อยมากกว่า 1 หน่วย',
    selectedProductHasNotSyncToHQYet: 'สินค้าที่เลือกยังไม่ได้ซิงค์กับสำนักงานใหญ่',
    onlySelect1ProductToProceed: 'เลือกสินค้าได้เพียง 1 รายการเท่านั้นเพื่อดำเนินการต่อ',
    selectedProductHasBeenLoadedToContainer: 'สินค้าที่เลือกถูกโหลดเข้าตู้คอนเทนเนอร์แล้ว',
    pleaseSelectAtLeast1DataFilter: 'กรุณาเลือกตัวกรองข้อมูลอย่างน้อย 1 รายการ',
    savedSuccess: 'บันทึกสำเร็จ',
    productAddedToContainer: 'เพิ่มสินค้าเข้าตู้คอนเทนเนอร์แล้ว',
    removeFromContainerSuccess: 'ลบออกจากตู้คอนเทนเนอร์สำเร็จ',
    productsSuccessDeleted: 'ลบสินค้าสำเร็จแล้ว'

}